/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateAuthLogoutResponse } from '../types/CandidateAuthLogout'

/**
 * POST /candidate-center/logout
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateAuthController.php CandidateAuthController::logout
 */
export async function candidateAuthLogout(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateAuthLogoutResponse>> {
	return axiosInstance.post('/candidate-center/logout', undefined, config)
}
